(function ($) {

    /**
     * Video
     */
    function initVideo() {
        const $winterBlogVideo = $("#winterBlogVideo");
        const $winterBlogVideoSource = $("#winterBlogVideoSrc");
        const $winterBlogVideoFallbackSource = $("#winterBlogVideoFallbackSource");

        const playVideo = function() {
            $winterBlogVideo[0].muted = true;
            $winterBlogVideo[0].load();
            $winterBlogVideo[0].play();
            $winterBlogVideo[0].playbackRate = 0.75;
        }

        let videoType = undefined;
        const changeIdNeeded = function () {
            if (window.innerWidth <= 768) {
                if(videoType === undefined || videoType !== "mobile") {
                    videoType = "mobile";
                    $winterBlogVideo.attr("poster", "https://cdn.shopify.com/s/files/1/0507/4357/4723/files/worn-when-it-counts__poster-05x.webp?v=1762428475g");
                    $winterBlogVideoSource.attr("src", "https://cdn.shopify.com/videos/c/o/v/ab2bbef52002469a9657be3e1a02c5de.webm");
                    $winterBlogVideoFallbackSource
                        .attr("src", "https://cdn.shopify.com/videos/c/o/v/c2b1b389b40a4e2fa1e679fd1441089d.mp4")
                        .attr("type", "video/mp4");
                    playVideo();
                }
            } else {
                if(videoType === undefined || videoType !== "desktop") {
                    videoType = "desktop";
                    $winterBlogVideo.attr("poster", "https://cdn.shopify.com/s/files/1/0507/4357/4723/files/worn-when-it-counts__poster-1x.webp?v=1762428493");
                    $winterBlogVideoSource.attr("src", "https://cdn.shopify.com/videos/c/o/v/bf64db581c434bc69f4472bd3697a98f.webm");
                    $winterBlogVideoFallbackSource
                        .attr("src", "https://cdn.shopify.com/videos/c/o/v/208b2444894245538f6806e68ac781dc.mp4")
                        .attr("type", "video/mp4");
                    playVideo();
                }
            }
        }

        $(window).on("resize", function() {
            changeIdNeeded();
        });
        changeIdNeeded();
    }
    initVideo();

})(jQuery)